<template>
  <div>
    <page-header
      :page="page"
      :has-return="false"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <ActionButton
          i="fas fa-arrow-circle-left"
          variant="ab-btn  ab-btn-outline-success m-1"
          @click="onReturn"
        >
          Regresar
        </ActionButton>
      </template>
    </page-header>
    <div class="row">
      <div class="col-11 mx-auto">
        <Board v-if="studentDetails" :details="studentDetails" />
      </div>
    </div>

    <time-line v-if="!meetingsSelected" class="mt-4 col-11 mx-auto px-0">
      <time-line-item
        v-for="(status, index) in statusHistory"
        :key="index"
        class="custom-time-line rounded"
      >
        <div class="row">
          <div class="col-12 col-md-2 flex-column d-flex border-right">
            <label class="mb-0 px-2 pt-1">Cambio de Estatus</label>
          </div>
          <div class="col-12 col-md-2 mt-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Usuario:</label>
            <span>{{ status.userName }}</span>
          </div>
          <div class="col-12 col-md-4 mt-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Nombre:</label>
            <span>{{ status.name }}</span>
          </div>
          <div class="col-12 col-md-4 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Estatus:</label>
            <span class="d-flex align-items-baseline">
              <div
                class="status-indicator"
                :style="{ backgroundColor: status.newStatus.color }"
              >
                &nbsp;
              </div>
              <span>{{ status.newStatus.text }}</span>
            </span>
          </div>
        </div>
        <template #icon>
          <em :class="`fas fa-exchange-alt text-white fa-lg`" class="radius" />
        </template>
        <template #date>
          <div class="date-container">
            <div class="color-black font-15 font-weight-bold fulldate">
              {{ formatDate(status.createDate) }}
            </div>
          </div>
        </template>
        <div id="comment-info" class="mt-3">
          <div class="info-panel bg-white rounded">
            <div class="row">
              <div class="col">
                <div class="info-panel-main-title">
                  <em class="fas fa-info-circle color-orange mr-2" />
                  <span class="color-gray-6 text-small">Descripción:</span>
                </div>
              </div>
            </div>
            <div class="info-panel-container">
              <div class="info-panel-item row">
                <div class="col-12 col-md-9">
                  <label>{{ buildReason(status) }}</label>
                </div>
                <div class="col-12 col-md-3">
                  <ActionButton
                    v-if="!!status.meetings && !!status.meetings.length"
                    i="fas fa-file-search"
                    variant="outline-success m-2"
                    :responsive="true"
                    @click="onMeetingsSelected(status)"
                  >
                    Ver Historial de Reuniones
                  </ActionButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </time-line-item>
    </time-line>
    <Meetings v-if="meetingsSelected" :data="selectedMeetings" />

    <div
      v-if="
        pagination.totalItemCount > 5 &&
          pagination.totalItemCount != statusHistory.length &&
          !meetingsSelected
      "
      class="row"
    >
      <div class="col text-center">
        <action-button
          variant="outline-success custom-view-more"
          i="fas fa-chevron-down"
          @click="loadMore"
        >
          Ver más Historial
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getHistory } from './_api';
import studentApi from '@/services/student.js';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import PageHeader from 'PageHeader';
import Meetings from '@/components/pei/ubication-tech-assistance/history/meetings';
import months from '@/utils/constants/months';
import ActionButton from 'ActionButton';

import Board from 'Board';

export default {
  name: 'UtaHistory',
  components: {
    Board,
    TimeLine,
    TimeLineItem,
    ActionButton,
    PageHeader,
    Meetings,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Historial de Consulta',
        routes: [
          'Inicio',
          'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        ],
      },
      payload: {
        RequestId: null,
        PageIndex: 1,
        PageSize: 5,
      },
      pagination: {
        totalItemCount: null,
        perPage: 5,
      },
      statusHistory: [],
      student: null,
      selectedMeetings: [],
      meetingsSelected: false,
    };
  },
  computed: {
    studentDetails() {
      if (!this.student) return;
      return [
        [
          {
            label: 'Estudiante',
            data: `${this.student.studentId} - ${this.student.fullName}`,
            icon: 'fas fa-address-book',
          },
          {
            label: 'Número de Consulta',
            data: this.businessId,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Escuela',
            data: `${this.student.schoolCode} - ${this.student.schoolName}`,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Impedimento',
            data: this.student.impediment,
            icon: 'fas fa-clipboard-list-check',
          },
        ],
      ];
    },
    businessId(){
      const statusHistory = this.statusHistory;
      const businessId = this.statusHistory.length > 0 ? this.statusHistory[0].businessId : '';
      return businessId;
    },
  },
  methods: {
    onReturn() {
      if (this.meetingsSelected) {
        this.meetingsSelected = false;
        this.selectedMeetings = [];
        this.getHistory();
      } else {
        this.$router.push({ name: 'uta-search' });
      }
    },
    onMeetingsSelected(status) {
      this.meetingsSelected = true;
      this.selectedMeetings = status;
      this.pagination.totalItemCount = status.meetings.length;
    },
    async getHistory() {
      const response = await getHistory(this.payload);
      this.statusHistory = response.data;
      this.pagination.totalItemCount = response.totalItemCount;
    },
    formatDate(value) {
      const date = new Date(value).toLocaleDateString('es-ES').split('/');
      return `${date[0]}/${months[date[1] - 1]}/${date[2]}`;
    },
    buildReason(status) {
      if (status.reason) return status.reason;

      return `Estatus cambiado de ${status.previousStatus.text} a ${status.newStatus.text}.`;
    },
    async loadMore() {
      this.payload.PageSize += this.pagination.perPage;
      await this.getHistory(this.payload);
    },
    async getStudent(sie) {
      const { data } = await studentApi.getBySie(sie);
      this.student = data;
    },
  },
  async created() {
    this.payload.RequestId = this.$route.params.tapRequestId;
    await Promise.all([
      this.getStudent(this.$route.params.studentSIE),
      this.getHistory(this.payload),
    ]);
  },
};
</script>

<style lang="scss" scoped>
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text-small {
  font-size: 0.875rem;
}
.info-panel {
  padding: 15px 10px 1px 20px;
  border-bottom: none;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}
.info-panel-container {
  display: flex;
  flex-flow: row wrap;
  padding: 0px 10px 1px 23px;
  .info-panel-item {
    flex: 1 0 25%;
    margin-bottom: 1.5em;
    float: left;
    box-sizing: border-box;
    padding-right: 10px;
    span {
      display: block;
      text-align: left;

      letter-spacing: 0px;
    }
    label {
      margin-top: 10px;
      text-align: left;
      font-size: 1rem;
      letter-spacing: 0px;

      line-height: 1.6em;
    }
  }
}

.date-container {
  width: 120px;
}
</style>